import { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import newIcon from '../assets/gifs/new-icon.gif';


export const Announcements = () => {
    const marqueeRef = useRef(null);
    const [showMarquee, setShowMarquee] = useState(false);
    const whatsappNumber = "+8619572907062"; // Replace with your actual WhatsApp number
    const whatsappNumberLink = `https://wa.me/${whatsappNumber}`;

    const styles = {
        wrapper: {
            // background: "#0b0e14",
            color: "#e6eef7",
            // borderRadius: 12,
            // border: "1px solid rgba(255,255,255,0.08)",
            // boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
            padding: 20,
            // margin: "24px auto",
            maxWidth: 1100,
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            marginBottom: 12,
        },
        headerTitle: {
            margin: 0,
            fontSize: 20,
            fontWeight: 700,
            letterSpacing: 0.2,
        },
        list: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
        },
        item: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 12,
            padding: 14,
            borderRadius: 10,
            // background: "#0b0e14",
            border: "1px solid rgba(255,255,255,0.06)",
        },
        icon: {
            flex: '0 0 auto',
            width: 42,
            height: 42,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 8,
            background: 'rgba(255,255,255,0.06)'
        },
        text: {
            margin: 0,
            lineHeight: 1.45,
            fontSize: 16,
        },
        note: {
            color: '#65d26e',
            fontWeight: 800,
        },
        link: {
            color: '#67b8ff',
            textDecoration: 'none',
        },
        viewMore: {
            color: '#67b8ff',
            textDecoration: 'none',
            fontSize: 13,
            fontWeight: 600,
            marginTop: 12,
            display: 'inline-block'
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowMarquee(true);
        }, 3000); // Delay marquee start by 3 seconds
        return () => clearTimeout(timer);
    }, []);

    return (
        <motion.div
            className="announcements-list"
            style={styles.wrapper}
            initial={{ opacity: 0, y: 100 }}
            transition={{ duration: 2 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.1 }}

        >
            <div style={styles.header}>
                <h3 style={styles.headerTitle}>Latest Announcements</h3>
            </div>
            <div style={styles.list}>
                <div className="announcement" style={styles.item}>
                    <div style={styles.icon}>
                        {/* <img src={newIcon} width="28" height="28" alt="New" /> */}
                        <strong style={{...styles.note, color:"red"}} >NEW</strong>
                    </div>
                    <p style={styles.text}>
                        Application window and scholarship is now open. Apply via <a href="/apply" style={styles.link}>AAS</a> or <a href="/AGFA/apply" style={styles.link}>AGFA</a>.
                    </p>
                </div>
                <div className="announcement" style={styles.item}>
                    <div style={styles.icon}>
                        {/* <img src={newIcon} width="28" height="28" alt="New" /> */}
                        <strong style={{...styles.note, color:"red"}} >NEW</strong>
                    </div>
                    <p style={styles.text}>
                        AAS currently accepts Bachelor and Master degree applications.
                    </p>
                </div>
                <div className="announcement" style={styles.item}>
                    <div style={styles.icon}>
                        {/* <img src={newIcon} width="28" height="28" alt="New" /> */}
                        <strong style={{...styles.note, color:"red"}} >NEW</strong>
                    </div>
                    <p style={styles.text}>
                        For Certificate, Diploma, and PhD applicants, apply via <a href="/AGFA/apply" style={styles.link}>AGFA</a>, contact us on <a href={whatsappNumberLink} style={styles.link} target="_blank" rel="noopener noreferrer">WhatsApp</a>, or <a href="mailto:athumanzathuman@gmail.com" style={styles.link} target="_blank" rel="noopener noreferrer">email us</a> for guidance.
                    </p>
                </div>
                <div className="announcement" style={styles.item}>
                    <div style={styles.icon}>
                        <strong style={styles.note}>NOTE</strong>
                    </div>
                    <p style={styles.text}>
                        If you apply through AGFA or AAS (selecting Other Universities or Other Courses), our admissions team will contact you after submission with a curated list of universities and courses to choose from.
                    </p>
                </div>
                <a href="/news" style={styles.viewMore}>view more →</a>
            </div>
        </motion.div>
    );
}
